import { useAccountFlags } from '@/hooks/use-account-flags';

/** The brand flag behind Rules (beta), set on Brand Settings. */
export const TICKET_RULES_FLAG = 'ticket_rules_enabled';

/** True when the selected brand runs its messages through Rules. Off while the flags load. */
export function useRulesEnabled(): boolean {
	const { flags } = useAccountFlags();
	return flags[TICKET_RULES_FLAG] === true;
}
